<template>
  <div class="home" :style="pageStyle">

    <img v-if="pageBg" class="bg" :src="pageBg" alt="">
    <Ship v-for="(item,idx) in comps"
          :key="item.id"
          :id="'ship_'+item.id"
          :pos="item.position"
          :zIndex="item.index"
          :left="item.left"
          :top="item.top"
          :rotate="item.rotate"
          :name="item.name"
          :fixed_bottom="item.fixed_bottom"
          :click_through='item.click_through'
          v-if="showComp(item)"
    >
      <component :is="item.type" :info="item"></component>
    </Ship>

    <ChannelChooser ref="channel_chooser"/>
  </div>

</template>

<script>

  import setTitle from '../tools/set-title'
  import {page_view, casherPV} from '../tools/mgtv/analysis'
  import {HOME_PAGE} from '../constant/analysis'
  import {setShare} from '../tools/mgtv/share'
  import Vue from 'vue';

  import preload from '../tools/preload'

  import UserInfo from '../components/ConfigUI/UserInfo.vue'
  import UserInfo2 from '../components/ConfigUI/UserInfo2.vue'
  import Ship from '../components/ConfigUI/Ship.vue'
  import Dialog from '../components/Popups/Dialog'
  import Toast from '../components/Popups/Toast'
  import HotSpot from '../components/ConfigUI/HotSpot.vue'
  import ActVideo from '../components/ConfigUI/ActVideo.vue'
  import ActPaomadeng from '../components/ConfigUI/ActPaomadeng.vue'
  import AppDownload from '../components/ConfigUI/AppDownload.vue'
  import ActImg from '../components/ConfigUI/ActImg.vue'
  import ChannelChooser from '../components/Popups/ChannelChooser.vue'
  import ActText from '../components/ConfigUI/ActText.vue'
  import Appointment from '../components/ConfigUI/Appointment.vue'
  import ActVideosRecommend from '../components/ConfigUI/ActVideosRecommend.vue'
  import get_open_id from '../tools/mgtv/openid'
  import LotteryRemainTimes from '../components/ConfigUI/Lottery/LotteryRemainTimes.vue'
  import ScratcherLottery from '../components/ConfigUI/Lottery/ScratcherLottery.vue'
  import CardLottery from '../components/ConfigUI/Lottery/CardLottery.vue'
  import InfiniteCardLottery from '../components/ConfigUI/Lottery/InfiniteCardLottery.vue'
  import ActMiaoSha from '../components/ConfigUI/ActMiaoSha'
  import ActLotteryCycle from '../components/ConfigUI/Lottery/ActLotteryCycle'
  import ActLotteryNine from '../components/ConfigUI/Lottery/ActLotteryNine'
  import ActVoteRank from '../components/ConfigUI/ActVoteRank.vue'
  import ActCountDown from '../components/ConfigUI/ActCountDown.vue'
  import ActMarquee from '../components/ConfigUI/ActMarquee.vue'
  import ActGift from '../components/ConfigUI/ActGift.vue'


  //  import ActSwipe from '../components/ConfigUI/ActSwipe.vue'


  //  import '../components/Popups/ImgDialog/index' //不再使用
  //  import  '../components/Popups/ShareDialog/index' //按条件加载
  //  import  '../components/Popups/HtmlDialog/index'　//按条件加载

  import {PAGE_CREATE} from '../constant/eventbus'
  import '../components/Popups/HtmlDialog/index'
  import '../components/Popups/ShareDialog/index'
  import '../components/Popups/SubmitDialog/index'
  import '../components/Popups/PreviewImgDialog/index'
  import '../components/Popups/ActAlertDialog/index'
  import '../components/Popups/LotteryHistoryDialog/index'
  import  '../components/Popups/TryUseChannelDialog/index'
  import  '../components/Popups/UnionVip/InputModal/index'
  import  '../components/Popups/UnionVip/PayModal/index'


  import {getTplValue} from '../tools/tpl'
  import {onUseInfoLoad} from '../tools/onUseInfoLoad'
  import {autoGetTryUseAward} from '../api/tryUse'

  export default {
    name: 'HomePage',
    components: {
      UserInfo,
      UserInfo2,
      Ship,
      HotSpot,
      ActVideo,
      AppDownload,
      ActImg,
      ChannelChooser,
      ActText,
      Appointment,
      ActVideosRecommend,
      LotteryRemainTimes,
      ScratcherLottery,
      CardLottery,
      InfiniteCardLottery,
      ActPaomadeng,
      ActMiaoSha,
      ActLotteryCycle,
      ActLotteryNine,
      ActVoteRank,
      ActCountDown,
      ActMarquee,
      ActGift
    },
    created() {
      let is_casher = false;
      window.$bus.tpl.comps.forEach(item => {
        switch (item.action_type) {
          //购买会员/购买联合会员，获取微信OPENID，且进行支付上报
          case 'openVip':
          case 'unionVIP':
            if (window.gact.is_wx) {
              get_open_id()
            }
            is_casher = true;
            break;
          case 'tryUse': //试用，如果是结果页面,获取试用结果
            onUseInfoLoad(() => {
              autoGetTryUseAward(item.action_info.try_product_id, item.action_info.try_days);
            });
            break;
          default:
            break;
        }

        switch (item.type) {
          case 'ActSwipe':
            Vue.component('ActSwipe', () => {
              import('jquery'); //Slick依赖jquery,防止还有其他组件依赖jquery,不直接在组件中使用
              return import('../components/ConfigUI/ActSwipe.vue');
            });
            break;
          default:
            break;
        }


      });

      if (is_casher) {
        casherPV(1);
      }
      setTimeout(() => {
        preload(window.rootdata.preload);
      }, 0);
    },
    mounted() {
      window.$channel_chooser = this.$refs.channel_chooser;
      setTimeout(() => {
        page_view(HOME_PAGE);
      }, 1500);
    },
    computed: {
      rootdata() {
        return window.$bus.rootdata
      },
      pageBg() {
        return window.$bus.tpl.page.page_img || ''
      },
      pageStyle() {
        return {
          backgroundColor: window.$bus.tpl.page.page_color
        }
      },
      page() {
        return window.$bus.tpl.page
      },
      comps() {
        return window.$bus.tpl.comps
      },
      getTplValue: getTplValue
    },
    methods: {
      showComp(item) { //判断组件是否可以展示

        if(item.hide){ //如果隐藏，直接不显示。
          return false
        }

        //以下是分端显示

        if (!item.enable_invoker) {
          return true
        }
        if (item.enable_invoker.indexOf('all') !== -1) {
          return true
        }
        else if (item.enable_invoker.indexOf(window.gact.invoker) !== -1) {
          return true
        }
        return false;
      }


    }
  }
</script>
<!--
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .home
    width: 7.5rem;
    position relative;
    display block;
    overflow hidden
    min-height 100vh
    .bg
      position relative
      display block
      width 7.5rem
</style>



// WEBPACK FOOTER //
// src/container/HomePage.vue